import logo from './logo.svg';
import './App.css';
import {useEffect, useState, useRef} from "react";
import { Routes, Route } from "react-router-dom"
import {Link} from 'react-router-dom';
import { art_projects, client_projects } from "./projects.js"
import Draggable from 'react-draggable'; // The default
import GridItem from './GridItem.js';
import useMouse from '@react-hook/mouse-position'

const randomPos = () => {
  var arr = [];
  var i;
  for(i=0;i<10;i++){
    arr.push(Math.random(0, 10))
  }
  return arr;
}
const Grid = ({type}) => {
  const ref = useRef(null)
  const mouse = useMouse(ref, {
    enterDelay: 100,
    leaveDelay: 100,
  })


  /////////
        if(type == "art"){
            var filterType = art_projects;
        } else {
            var filterType = client_projects;
        }
  return (
<div className="grid" ref={ref}>
  {type == "other" &&
  "Various smaller works and projects. Most of them are assignments from Parsons School of Design."}
    {filterType.map((item, i) => (
          <GridItem img={item.thumb} title={item.title} year={item.year} slug={item.slug} mouseX={mouse.x} mouseY={mouse.y} />
    ))}
    </div>
  );
}

export default Grid;
